import { makeStyles } from 'tss-react/mui'

export const useStyle = makeStyles()(theme => ({
  accordionHeader: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  accordionHeaderIcon: {
    display: 'flex',
  },
  completedIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.5),
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    backgroundColor: theme.palette.textBackground.dark,
    borderRadius: '50%',
  },
  completedIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.text.white,
  },
  accordionIconContainer: {
    marginRight: theme.spacing(1.5),
    height: theme.spacing(3.5),
    width: theme.spacing(3.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.bgSecondary.main,
    borderRadius: '50%',
  },
  accordionIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.labraText.primary,
  },
  accordionHeaderText: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.primary,
    lineHeight: '20px',
    fontStyle: 'normal',
    letterSpacing: '0.25px',
  },
  accordionDescription: {
    width: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontStyle: 'normal',
    letterSpacing: '0.25px',
    paddingLeft: theme.spacing(4),
  },
  buttonContainer: {
    marginTop: theme.spacing(1.5),
  },
}))
